<div class="ct-container">
  <div class="ct-main-content">
    <div class="customer-login">
      <label for="name" class="field-label">Nome</label>
      <input id="name" class="form-control" type="text" [(ngModel)]="customer.name" (keyup)="checkNameFormat(customer, 'name')"/>
      <br/>

      <label for="surname" class="field-label">Sobrenome</label>
      <input id="surname" class="form-control" type="text" [(ngModel)]="customer.surname" (keyup)="checkNameFormat(customer, 'surname')"/>

      <br/>

      <label for="phone" class="field-label">Telefone</label>
      <input id="phone" class="form-control" type="text" [(ngModel)]="customer.phone" mask="(00) 0 0000-0000"/>

      <br/>
      <div class="send-button">
        <button class="btn btn-lg btn-success" (click)="send()" [disabled]="sending">
          @if (!sending) {
            <span>
              ENVIAR
            </span>
          }
          @if (sending) {
            <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
          }
        </button>
      </div>
    </div>
  </div>
</div>